import React from "react";
import { useLocation } from "react-router-dom";

const data = [
  { title: "React Guide", link: "/react" },
  { title: "JavaScript Tutorial", link: "/javascript" },
  { title: "Web Design Tips", link: "/design" },
  { title: "CSS Animation", link: "/css" }
];

function SearchPage() {
  const query = new URLSearchParams(useLocation().search).get("q");

  const results = data.filter((item) =>
    item.title.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div style={{ padding: "120px 40px" }}>
      <h2>Search Results for "{query}"</h2>

      {results.length > 0 ? (
        results.map((item, index) => (
          <div key={index}>
            <a href={item.link}>{item.title}</a>
          </div>
        ))
      ) : (
        <p>No results found</p>
      )}
    </div>
  );
}

export default SearchPage;
